<app-toast></app-toast>

<!-- DS CMS layout: a full-width dark topbar, then a row of sidebar + main.
     The outer column fills the viewport; only the main area scrolls.
     bareLayout routes (the error pages) drop all chrome: their context is
     broken or absent, so org-scoped nav links would hang or lie. -->
<div class="flex h-screen flex-col overflow-hidden">
  @if (!bareLayout()) {
    <app-topbar (menuClick)="navDrawerOpen.set(true)" />
  }

  <div class="flex min-h-0 flex-1">
    <!-- Sidebar (design system LeftMenu). 296px per the DS spec; hidden below
         md, where the topbar hamburger opens it as a drawer instead. -->
    <!-- The nav list scrolls internally; the user-card zone stays pinned. -->
    <!-- 296px per the DS spec, but only on genuinely wide screens (2xl+);
         240px on small tablets (md–lg), 256px on laptops (lg–2xl). -->
    @if (!bareLayout()) {
      <app-navbar
        [navbarItems]="navbarItems()"
        class="hidden w-60 shrink-0 md:block lg:w-64 2xl:w-[296px]"
      ></app-navbar>
    }

    <main class="min-w-0 flex-1 overflow-y-auto" [class.p-4]="!bareLayout()">
      @if (!bareLayout()) {
        <app-breadcrumbs />
      }
      <router-outlet />
    </main>
  </div>
</div>

<!-- Phone-shell nav drawer: the same navbar, slid in over the content. Sibling
     @ifs so scrim and panel each root their own view — animate.leave defers
     removal per element. Closed by scrim tap, Escape, navigation, or crossing
     the md breakpoint (see AppComponent). -->
@if (navDrawerOpen()) {
  <div
    class="fixed inset-0 z-50 bg-scrim-control md:hidden"
    animate.enter="nav-scrim-in"
    animate.leave="nav-scrim-out"
    (click)="closeNavDrawer()"
    aria-hidden="true"
  ></div>
}
@if (navDrawerOpen()) {
  <div
    role="dialog"
    aria-modal="true"
    class="fixed inset-y-0 left-0 z-50 w-[296px] max-w-[85vw] bg-page shadow-overlay md:hidden"
    animate.enter="nav-drawer-in"
    animate.leave="nav-drawer-out"
  >
    <app-navbar [navbarItems]="navbarItems()" class="block h-full" />
  </div>
}
